import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './cra-default/reportWebVitals';

import App from 'pages/App';
import "semantic-ui-css/semantic.min.css";

// <React.StrictMode>
//  <App/>
// </React.StrictMode>

ReactDOM.render(
  <App />
  ,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console. log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
